import React, {useState, useEffect} from 'react';
import Routes from './routes/routes';
import {withRouter} from 'react-router-dom';
import RootContainer from './containers/RootContainer';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const App: React.FC = () => {
  
  useEffect(()=>{
    console.log("Second Line");
  },[])

  return (
    <RootContainer>
      <Routes />
    </RootContainer>
  );
};

export default withRouter(App);
